// semeia-disable-reexport
import AbdominalPain from "./abdominal-pain";
import AbdominalPainIntensity from "./abdominal-pain-intensity";
import AnalIncontinence from "./anal-incontinence";
import AnalIncontinenceFrequency from "./anal-incontinence-frequency";
import AnusSymptoms from "./anus-symptoms";
import AnusSymptomsFrequency from "./anus-symptoms-frequency";
import ArticularPain from "./articular-pain";
import ArticularPainIbd from "./articular-pain-ibd";
import ArticularPainSeverity from "./articular-pain-severity";
import AverageStoolsNumber from "./average-stools-number";
import BloodInStool from "./blood-in-stool";
import BloodInStoolFrequency from "./blood-in-stool-frequency";
import BodyDissatisfaction from "./body-dissatisfaction";
import EyeSymptoms from "./eye-symptoms";
import EyeSymptomsPainful from "./eye-symptoms-painful";
import EyeSymptomsRedEye from "./eye-symptoms-red-eye";
import EyeSymptomsSight from "./eye-symptoms-sight";
import Fever from "./fever";
import FeverLevel from "./fever-level";
import FistulasEmbarrassment from "./fistulas-embarrassment";
import FistulasFlow from "./fistulas-flow";
import FistulasMovement from "./fistulas-movement";
import FistulasPain from "./fistulas-pain";
import FistulasPainSkin from "./fistulas-pain-skin";
import HasFistulas from "./has-fistulas";
import ImmediateStool from "./immediate-stool";
import ImmediateStoolUrgency from "./immediate-stool-urgency";
import LackOfEnergy from "./lack-of-energy";
import LowMood from "./low-mood";
import MouthUlcers from "./mouth-ulcers";
import RepeatedVomiting from "./repeated-vomiting";
import SexualDifficulties from "./sexual-difficulties";
import SkinSymptoms from "./skin-symptoms";
import SleepDifficulties from "./sleep-difficulties";
import Slider from "./slider";
import SocialDifficulties from "./social-difficulties";
import StomachPain from "./stomach-pain";
import StoolsNumber from "./stools-number";
import TransitBlockage from "./transit-blockage";
import UrgentStoolsMovements from "./urgent-stools-movements";
import Weight from "./weight";
import WellBeing from "./well-being";
import WorkDifficulties from "./work-difficulties";
const Sections = {
  "abdominal-pain": AbdominalPain,
  "abdominal-pain-intensity": AbdominalPainIntensity,
  "anal-incontinence": AnalIncontinence,
  "anal-incontinence-frequency": AnalIncontinenceFrequency,
  "anus-symptoms": AnusSymptoms,
  "anus-symptoms-frequency": AnusSymptomsFrequency,
  "articular-pain": ArticularPain,
  "articular-pain-ibd": ArticularPainIbd,
  "articular-pain-severity": ArticularPainSeverity,
  "average-stools-number": AverageStoolsNumber,
  "blood-in-stool": BloodInStool,
  "blood-in-stool-frequency": BloodInStoolFrequency,
  "body-dissatisfaction": BodyDissatisfaction,
  "eye-symptoms": EyeSymptoms,
  "eye-symptoms-painful": EyeSymptomsPainful,
  "eye-symptoms-red-eye": EyeSymptomsRedEye,
  "eye-symptoms-sight": EyeSymptomsSight,
  fever: Fever,
  "fever-level": FeverLevel,
  "fistulas-embarrassment": FistulasEmbarrassment,
  "fistulas-flow": FistulasFlow,
  "fistulas-movement": FistulasMovement,
  "fistulas-pain": FistulasPain,
  "fistulas-pain-skin": FistulasPainSkin,
  "has-fistulas": HasFistulas,
  "immediate-stool": ImmediateStool,
  "immediate-stool-urgency": ImmediateStoolUrgency,
  "lack-of-energy": LackOfEnergy,
  "low-mood": LowMood,
  "mouth-ulcers": MouthUlcers,
  "repeated-vomiting": RepeatedVomiting,
  "sexual-difficulties": SexualDifficulties,
  "skin-symptoms": SkinSymptoms,
  "sleep-difficulties": SleepDifficulties,
  slider: Slider,
  "social-difficulties": SocialDifficulties,
  "stomach-pain": StomachPain,
  "stools-number": StoolsNumber,
  "transit-blockage": TransitBlockage,
  "urgent-stools-movements": UrgentStoolsMovements,
  weight: Weight,
  "well-being": WellBeing,
  "work-difficulties": WorkDifficulties
};
export default Sections;